import { IonIcon } from '@ionic/react'
import { ENodeVehicle } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import dayjs from 'dayjs'
import { chevronDown } from 'ionicons/icons'
import React, { useContext } from 'react'
import { ModalContext } from '../../../../contexts/ModalContext'

interface Props {
	vehicles: ENodeVehicle[]
}

export const SmartChargeController: React.FC<Props> = ({ vehicles }) => {
	const { insertModal, setSelectedVehicles, timeValue } = useContext(ModalContext)

	const openModal = () => {
		setSelectedVehicles(vehicles)
		insertModal('smartChargeController')
	}

	return (
		<div
			onClick={openModal}
			className='p-2 my-2 rounded-xl border dark:border-brand-primary-100-dark border-brand-primary-100-light bg-brand-secondary-200-light dark:bg-surface-dark flex items-center gap-2 cursor-pointer'
		>
			<span className='dark:text-white'>
				{vehicles[0]?.smartChargingPolicy.deadline ?? dayjs(timeValue).format('HH:mm')}
			</span>
			<IonIcon className='dark:text-[#c8c8c8]' icon={chevronDown} />
		</div>
	)
}
